import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { useUserDetails } from "../../context/auth";
import { useLoading } from "../../context/loading";
const Shift = () => {
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();
  const { circleLoading, setCirleLoading } = useLoading();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [shiftList, setShiftList] = useState([]);

  useEffect(() => {
    onShiftDetails();
  }, []);

  const shiftListTable = {
    columns: [
      {
        field: "name",
        headerName: "Shift Name",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "total",
        headerName: "Shift Duration",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: shiftList.map((shift) => ({
      id: shift.id,
      name: shift.name,
      total: shift?.totalWorkingHours / 3600,
    })),
  };

  const handleNewShift = () => {
    navigate("/shift/add-shift");
  };

  const onShiftListClick = (e) => {
    if (e?.id) {
      navigate(`/shift/shift-details?id=${e?.id}`);
    }
  };

  const onShiftDetails = async () => {
    setCirleLoading(true);
    const query = `
        query allShifts{
  allShifts {
    id
    name
    startTime
    endTime
    totalWorkingHours
  }
}
        `;
    try {
      setPageState((prev) => ({ ...prev, loading: true }));

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response:", response);

      const shiftData = response.data?.data?.allShifts; // Adjusted field name
      if (shiftData) {
        setShiftList(shiftData);
        setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
      } else {
        console.error("Error: Shift data not found in response.");
        setPageState((prev) => ({
          ...prev,
          loading: false,
          error: true,
          message: "No shift data available.",
        }));
      }
      setCirleLoading(false);
    } catch (error) {
      setCirleLoading(false);
      console.error("ResponseError:", error);
      setPageState((prev) => ({
        ...prev,
        loading: false,
        error: true,
        message: "Network error, please try again later.",
      }));
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Shift List
                </MaterialTypography>
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddShift" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleNewShift}
                  >
                    Add Shift
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={shiftListTable.rows}
          columns={shiftListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onShiftListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No shifts found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any shift details. Click on the "Add
                  Shift" button to start adding shift details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Shift;
